import React, { useContext, useEffect } from 'react'
import { HeadingContext } from '../context/HeadingContext';

function Guest() {

  const { setHeading } = useContext(HeadingContext);

  useEffect(() => {
    setHeading('Guest');
  }, [setHeading]);

  return (
    <div>Guest</div>
  )
}

export default Guest